
import { AxiosResponse } from 'axios'
import { defineComponent } from 'vue'
import { FilterMatchMode, FilterOperator } from 'primevue/api'
import { ICatalogFunctionTemplate } from '@/modules/importExport/catalogFunction/ICatalogFunctionTemplate'
import { IGalleryTemplate } from '@/modules/managers/galleryManagement/GalleryManagement'
import { ITableColumn } from '../commons/ITableColumn'
import Avatar from 'primevue/avatar'
import Badge from 'primevue/badge'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import FileUpload from 'primevue/fileupload'
import importExportDescriptor from './ImportExportDescriptor.json'
import Message from 'primevue/message'
import TabPanel from 'primevue/tabpanel'
import TabView from 'primevue/tabview'
import Tag from 'primevue/tag'

export default defineComponent({
    name: 'import-dialog',
    components: { Avatar, Badge, Column, DataTable, Dialog, FileUpload, Message, TabPanel, TabView, Tag },
    props: {
        visibility: Boolean
    },
    data() {
        return {
            importExportDescriptor: importExportDescriptor,
            uploadedFiles: [],
            fileName: '',
            filters: {},
            loading: false,
            packageItems: {
                gallery: Array<IGalleryTemplate>(),
                catalogFunction: Array<ICatalogFunctionTemplate>()
            },
            selectedItems: {
                gallery: Array<IGalleryTemplate>(),
                catalogFunction: Array<ICatalogFunctionTemplate>()
            },
            step: 0,
            token: ''
        }
    },
    emits: ['update:visibility', 'import'],
    created() {
        this.filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            name: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            type: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            tags: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }
        }
    },
    methods: {
        async cleanTempDirectory() {
            if (this.token != '') {
                this.uploadedFiles = []
                await this.$http.get(process.env.VUE_APP_API_PATH + '1.0/import/cleanup', { params: { token: this.token } }).then(
                    () => {
                        this.token = ''
                        this.packageItems = {
                            gallery: [],
                            catalogFunction: []
                        }
                    },
                    (error) => console.log(error)
                )
            }
        },
        closeDialog(): void {
            this.$emit('update:visibility', false)
        },
        emitImport(): void {
            this.$emit('import', { files: this.uploadedFiles })
        },
        getData(type): Array<ITableColumn> {
            let columns = this.importExportDescriptor['import'][type]['column']
            columns.sort(function(a, b) {
                if (a.position > b.position) return 1
                if (a.position < b.position) return -1
                return 0
            })
            return columns
        },
        getMessageWarningCondition() {
            return this.selectedItems.gallery.filter((e) => !e.id || (e.id && (e.id === '' || e.id === null))).length > 0
        },
        getPackageItems(e) {
            this.packageItems[e.functionality] = e.items
        },
        getSelectedItems(e) {
            this.selectedItems[e.functionality] = e.items
        },
        async goToChooseElement(uploadedFiles) {
            if (this.uploadedFiles.length == 1) {
                this.loading = true
                this.step = 1

                var formData = new FormData()
                formData.append('file', uploadedFiles[0])
                await this.$http
                    .post(process.env.VUE_APP_API_PATH + '1.0/import/upload', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(
                        (response: AxiosResponse<any>) => {
                            this.packageItems = response.data.entries
                            this.token = response.data.token
                            this.step = 1
                        },
                        () => this.$store.commit('setError', { title: this.$t('common.error.uploading'), msg: this.$t('importExport.import.completedWithErrors') })
                    )
                this.loading = false
            } else {
                this.$store.commit('setWarning', { title: this.$t('common.uploading'), msg: this.$t('managers.widgetGallery.noFileProvided') })
            }
        },
        isImportDisabled(): Boolean {
            for (var idx in this.selectedItems) {
                if (this.selectedItems[idx].length > 0) return false
            }
            return true
        },
        onDelete(idx) {
            this.uploadedFiles.splice(idx)
        },
        onUpload(data) {
            // eslint-disable-next-line
            // @ts-ignore
            this.uploadedFiles[0] = data.files[0]
        },
        resetAndClose(): void {
            this.resetToFirstStep()
            this.closeDialog()
        },
        resetSearchFilter(): void {
            this.filters['global'].value = ''
        },
        async resetToFirstStep() {
            this.step = 0
            this.selectedItems = {
                gallery: [],
                catalogFunction: []
            }
            this.packageItems = {
                gallery: [],
                catalogFunction: []
            }
            this.cleanTempDirectory()
        },

        startImport() {
            this.$store.commit('setLoading', true)
            this.$http
                .post(process.env.VUE_APP_API_PATH + '1.0/import/bulk', this.streamlineSelectedItemsArray(), {
                    headers: {
                        // Overwrite Axios's automatically set Content-Type
                        'Content-Type': 'application/json'
                    }
                })
                .then(
                    () => {
                        this.$store.commit('setInfo', { title: this.$t('common.import'), msg: this.$t('importExport.import.successfullyCompleted') })

                        this.$store.commit('setLoading', false)
                    },
                    () => this.$store.commit('setError', { title: this.$t('common.error.import'), msg: this.$t('importExport.import.completedWithErrors') })
                )
            this.token = ''
            this.resetAndClose()
        },

        streamlineSelectedItemsArray(): JSON {
            let selectedItemsToBE = {} as JSON
            selectedItemsToBE['selectedItems'] = {}
            for (var category in this.selectedItems) {
                for (var k in this.selectedItems[category]) {
                    if (!selectedItemsToBE['selectedItems'][category]) {
                        selectedItemsToBE['selectedItems'][category] = []
                    }

                    selectedItemsToBE['selectedItems'][category].push(this.selectedItems[category][k].id)
                }
            }

            selectedItemsToBE['token'] = this.token

            return selectedItemsToBE
        }
    }
})
